"use client";

import { c as _c } from "react/compiler-runtime";
import { ErrorBoundaryFallback } from "@/components/common/error-boundary-fallback";
export default function AppError(t0) {
  const $ = _c(2);
  const {
    reset
  } = t0;
  let t1;
  if ($[0] !== reset) {
    t1 = <ErrorBoundaryFallback reset={reset} />;
    $[0] = reset;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}